import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import SearchBar from './SearchBar';

const Header = ({ language, changeLanguage, t, scrollToSection }) => {
  const languages = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'nl', label: 'Nederlands', flag: '🇳🇱' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-5">
            <div className="h-32 w-32 flex-shrink-0">
              <img 
                src="/logo-icon.png" 
                alt="Mediation Partners Icon" 
                className="w-full h-full object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-[#1e5f8c] leading-tight">
                Mediation Partners
              </span>
              <span className="text-sm md:text-base text-[#1e5f8c] opacity-80 leading-tight">
                Mediation and advisory for complex situations
              </span>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-navy-600 transition-colors">
              {t.nav.about}
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-navy-600 transition-colors">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('team')} className="text-gray-700 hover:text-navy-600 transition-colors">
              {t.nav.team}
            </button>
            <Link to="/blog" className="text-gray-700 hover:text-navy-600 transition-colors font-medium">
              Blog
            </Link>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-navy-600 transition-colors">
              {t.nav.contact}
            </button>
            
            {/* Search Bar */}
            <SearchBar t={t} scrollToSection={scrollToSection} language={language} />
            
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="gap-2">
                  <Globe className="h-4 w-4" />
                  <span>{currentLanguage.flag}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {languages.map((lang) => (
                  <DropdownMenuItem
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    className={language === lang.code ? 'bg-navy-50' : ''}
                  >
                    <span className="mr-2">{lang.flag}</span>
                    {lang.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
            
            <Button onClick={() => scrollToSection('booking')} className="bg-navy-600 hover:bg-navy-700">
              {t.nav.bookConsultation}
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;